// https://api.anano.com.br/storage/dw/buckets/anano.data.ui/arquivos/a00e3f3e-3ced-4d31-afc1-d17c667006c3/download?access_token=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJqYW9hc3N5IiwiaWF0IjoxNjk2MjUxNjUzLCJleHAiOjE3MTE4MDM2NTN9.Yyc6BZpewKc-rfg4309cxVPD5JcGujVgUrhBxnIhoTM
import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loading: true,
    desempenho: null,
    distribuicao: null,
    versao: 0,
    data: null,
    produtos: [],
    produtosExpostos: [],
    fornecedores: [],
    fornecedoresExpostos: [],
    relatorio: null,
    filtros: {
        nome: null,
        ordem: null,
        somenteCompras: false,
        excedenteNaoEncalhado : false,
    },
    metricas: {
        numeroItems: 0,
        nomeFornecedor: null,
    }
}

var novaOrdem = (codigo, label) => {
    return { codigo, label }
}

var novoFiltro = (listagem, ordem, curva, somenteCompras, fornecedorId, excedenteNaoEncalhado) => {
    return {
        listagem,
        ordem,
        curva,
        somenteCompras,
        fornecedorId,
        excedenteNaoEncalhado
    }
}

export const estoqueSlice = createSlice({
    name: "estoque",
    initialState,
    reducers: {
        // Saga
        triggerChangeNome: () => { },
        triggerTrocaFiltroRelatorio: () => { },
        triggerTrocaRelatorio: () => { },
        triggerLoadDados: () => { },

        // Slice
        setAttribute: (state, action) => {
            state[action.payload.campo] = action.payload.valor
        },
        filtrarEhOrdenar: (state) => {
            var filtros = state.filtros
            var listagem = state.filtros.listagem

            var ehProduto = listagem === "PRODUTO"

            var lista = [...(ehProduto ? state.produtos : state.fornecedores)]

            if (filtros.fornecedorId != null) {
                lista = lista.filter(p => p.fornecedores.filter(f => f.codigo == filtros.fornecedorId).length > 0)
                state.metricas.nomeFornecedor = state.fornecedores.filter(f => f.codigo == filtros.fornecedorId)[0].descricao
            } else {
                state.metricas.nomeFornecedor = null
            }

            if(filtros.excedenteNaoEncalhado === true) {
                lista = lista.filter(p => p.estoque.atual > p.estoque.exagerado && p.curva != "D")
            } 

            if (filtros.curva !== null) {
                lista = lista.filter(p => p.curva === filtros.curva)
            }

            if (filtros.somenteCompras && listagem == "PRODUTO") {
                lista = lista.filter(p => p.estoque.compra.minima > 0)
            }

            if (filtros.nome != null && filtros.nome.trim().length > 0) {
                var nome = filtros.nome
                lista = lista.filter(p => {
                    if (nome != null && nome.trim().length > 0) {
                        return p.descricao.toUpperCase().includes(nome.toUpperCase())
                    }

                    return true
                })
            }

            switch (filtros.ordem.codigo) {
                case 'NOME':
                    lista = lista.sort((a, b) => a.descricao > b.descricao ? 1 : -1)
                    break
                case 'LUCRO':
                    lista = lista.sort((a, b) => a.retornoMensal > b.retornoMensal ? -1 : 1)
                    break
                case 'CUSTO':
                    lista = lista.sort((a, b) => a.estoque.custo > b.estoque.custo ? -1 : 1)
                    break
                case 'SITUACAO':
                    lista = lista.sort((a,b) => a.situacao.nivel > b.situacao.nivel ? 1 : -1)
                    break
                case 'PERDA':
                    var calculaCoeficiente = (x) => x.perdas.lucro > 0
                        ? x.perdas.lucro :
                        x.perdas.oportunidade > 0 ?
                            x.perdas.oportunidade : 0

                    var sortAB = (a,b) =>
                    calculaCoeficiente(a) > calculaCoeficiente(b) ? -1 :
                        calculaCoeficiente(a) < calculaCoeficiente(b) ? 1 : 0

                    var primeira = lista.filter(a => a.perdas.lucro != 0 || a.perdas.oportunidade != 0).sort(sortAB)

                    lista = [...primeira,  ...lista.filter(a => a.perdas.lucro == 0 && a.perdas.oportunidade == 0)]
            }

            state.metricas.numeroItems = lista.length

            if (ehProduto) {
                state.produtosExpostos = lista
            } else {
                state.fornecedoresExpostos = lista
            }


        },
        setRelatorio: (state, action) => {

            var codigo = action.payload.codigo
            var id = action.payload.id

            var listagem = "PRODUTO"
            var filtro = {}

            function novoRelatorio(codigo, id) {

                var descricao = ""

                switch (codigo) {
                    case "REL_SUGESTAO_COMPRA":
                        descricao = "Sugestões de compra por fornecedor"
                        listagem = "FORNECEDOR"
                        filtro = novoFiltro(
                            listagem,
                            novaOrdem("AUTO", "Maiores perdas"))
                        break
                    case "REL_LIQUIDACOES":
                        descricao = "Curva D - Liquidações"
                        filtro = novoFiltro(
                            listagem,
                            novaOrdem("PERDA", "Perda de desempenho estimada"),
                            "D")
                        break
                    case "REL_PROMOCOES":
                        descricao = "Promoções"
                        // produtos = state.produtos.filter(e => e.situacao.nivel == 4)
                        //     .sort((a, b) => a.perdas.oportunidade > b.perdas.oportunidade ? -1 : 1)
                        filtro = novoFiltro(
                            listagem,
                            novaOrdem("PERDA", "Perda de desempenho estimada"),
                            null,
                            null,
                            null,
                            true)
                        break
                    case "REL_CURVA_A":
                        descricao = "Curva A"
                        filtro = novoFiltro(
                            listagem,
                            novaOrdem("AUTO", "Maior retorno mensal"),
                            "A")
                        break
                    case "REL_CURVA_B":
                        descricao = "Curva B"
                        filtro = novoFiltro(
                            listagem,
                            novaOrdem("AUTO", "Maior retorno mensal"),
                            "B")
                        break
                    case "REL_CURVA_C":
                        descricao = "Curva C"
                        filtro = novoFiltro(
                            listagem,
                            novaOrdem("AUTO", "Maior retorno mensal"),
                            "C")
                        break
                    case "REL_PROD_FORN":
                        descricao = "Produtos por fornecedor"
                        var somenteCompras = true
                        var fornecedorId = id
                        filtro = novoFiltro(
                            listagem,
                            novaOrdem("PERDA", "Perda de desempenho estimada"),
                            null,
                            somenteCompras,
                            fornecedorId)
                }

                return {
                    codigo,
                    descricao,
                }

            }

            state.relatorio = novoRelatorio(codigo, id)
            state.filtros = filtro

        },
    }
})

export const {
    setAttribute,
    triggerTrocaRelatorio,
    triggerTrocaFiltroRelatorio,
    triggerLoadDados,
    triggerChangeNome,
    setRelatorio,
    filtrarEhOrdenar
} = estoqueSlice.actions;


export default estoqueSlice.reducer;